/*
  Склонение по числу — по правилам русского: 1 сервис, 2–4 сервиса, 5–20 сервисов; 11–14 — всегда
  «много» (11 сервисов, 112 сервисов), 21 — снова «один» (21 сервис).
*/

export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n));
  const d = abs % 10;
  const h = abs % 100;
  if (h >= 11 && h <= 14) return many;
  if (d === 1) return one;
  if (d >= 2 && d <= 4) return few;
  return many;
}
